import CustomMenu from './CustomMenu.jsx'

export default CustomMenu
